import { render, staticRenderFns } from "./real-time-answers.vue?vue&type=template&id=e832a5a0&scoped=true&"
import script from "./real-time-answers.vue?vue&type=script&lang=js&"
export * from "./real-time-answers.vue?vue&type=script&lang=js&"
import style0 from "./real-time-answers.vue?vue&type=style&index=0&id=e832a5a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e832a5a0",
  null
  
)

export default component.exports